import rgbToCmyk from './rgbToCmyk';
import hexToRgb from './hexToRgb';

export default function(hex) {
  const rgb = hexToRgb(hex);
  return rgbToCmyk(rgb);
}
